"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.library = void 0;
var env_1 = require("../../env");
exports.library = {
  id: 'library',
  label: 'Library',
  scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:library'] : null,
  children: [{
    id: 'feed-entries',
    type: 'list',
    entityTypeName: 'FeedEntry',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:feed-entries'] : null
  }, {
    id: 'videos',
    type: 'list',
    entityTypeName: 'Video',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:videos'] : null
  }, {
    id: 'images',
    type: 'list',
    entityTypeName: 'ImageAsset',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:images'] : null
  }, {
    id: 'banners',
    type: 'list',
    entityTypeName: 'Banner',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:banners'] : null
  }, {
    id: 'files',
    type: 'list',
    entityTypeName: 'FileAsset',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:files'] : null
  }, {
    id: 'links',
    type: 'list',
    entityTypeName: 'Link',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:links'] : null
  }, {
    id: 'citations',
    type: 'list',
    entityTypeName: 'Citation',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:citations'] : null
  }, {
    id: 'quotes',
    type: 'list',
    entityTypeName: 'Quote',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:quotes'] : null
  }, {
    id: 'feeds',
    type: 'list',
    entityTypeName: 'Feed',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:feeds'] : null
  }, {
    id: 'products',
    type: 'list',
    entityTypeName: 'Product',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:products'] : null
  }]
};